import DownloadIcon from '@mui/icons-material/Download';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { formatDate } from '@/shared/utils/format-date.js';

export interface DocumentDownloadRowProps {
    label: string;
    uploadedAt: string;
    downloadAriaLabel: string;
    onDownload: () => void;
}

export function DocumentDownloadRow({ label, uploadedAt, downloadAriaLabel, onDownload }: DocumentDownloadRowProps) {
    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="body2" noWrap sx={{ flex: 1, minWidth: 0 }}>
                {label}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
                {formatDate(uploadedAt)}
            </Typography>
            <IconButton size="small" aria-label={downloadAriaLabel} onClick={onDownload}>
                <DownloadIcon fontSize="small" />
            </IconButton>
        </Stack>
    );
}
